import { render, staticRenderFns } from "./ResetProgressModal.vue?vue&type=template&id=080bd237"
import script from "./ResetProgressModal.vue?vue&type=script&lang=js"
export * from "./ResetProgressModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports